// extracted by mini-css-extract-plugin
module.exports = {"title":"a10a3f92e9--title--2JVT3","market-price":"a10a3f92e9--market-price--19IcM","chart":"a10a3f92e9--chart--pe28v","button":"a10a3f92e9--button--23fwq"};